import { Dispatch, SetStateAction } from 'react';
import { WhiteLabelPaths } from '@/app/types/types';
import { Button, Flex, Modal, Spacing08, WhiteLabelValues } from '@nyshex/keel';

const ModalFooter = ({
  setIsOpen,
  setGdprModalOpen,
  whiteLabel,
}: {
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setGdprModalOpen: Dispatch<SetStateAction<boolean>>;
  whiteLabel: WhiteLabelPaths | undefined;
}) => {
  const handleDecline = () => {
    setGdprModalOpen(false);
  };

  const handleTakeMeBack = async () => {
    setIsOpen(false);
  };

  return (
    <Flex gap={Spacing08}>
      <Button
        content="No, take me back"
        variant="secondary"
        size="sm"
        whiteLabel={whiteLabel as unknown as WhiteLabelValues}
        onClick={handleTakeMeBack}
        testId="takeMeBackButton"
      />
      <Button
        content="Decline terms and log out"
        variant="danger"
        size="sm"
        onClick={handleDecline}
        whiteLabel={whiteLabel as unknown as WhiteLabelValues}
        testId="declineTermsButton"
      />
    </Flex>
  );
};

export const DeclineGdpModal = ({
  isOpen,
  setIsOpen,
  setGdprModalOpen,
  whiteLabel,
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setGdprModalOpen: Dispatch<SetStateAction<boolean>>;
  whiteLabel: WhiteLabelPaths | undefined;
}) => {
  return (
    <Modal
      setIsOpen={setIsOpen}
      isOpen={isOpen}
      title="By declining our terms, you will lose access to NYSHEX"
      footer={
        <ModalFooter
          setIsOpen={setIsOpen}
          setGdprModalOpen={setGdprModalOpen}
          whiteLabel={whiteLabel}
        />
      }
    >
      If you decline the updated terms of our privacy policy you will not be
      permitted to access our system and will be sent back to the log in page.
      <br />
      <br />
      We care about your privacy and that’s why we were already GDPR compliant,
      and why we only store customer data that is needed to provide our
      services. We also think privacy is for everyone, which is why we’re
      ensuring that our policies continue to meet the high standard of the
      European data protection laws, and why we’re extending the same rights to
      all our users, inside and outside the EU.
    </Modal>
  );
};
